module.exports = __webpack_public_path__ + "img/person-icon.0f4edffc.png";